
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'new-dwellings-map',
    imports: [RouterModule],
    templateUrl: './new-dwellings-map.component.html',
    styleUrl: './new-dwellings-map.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewDwellingsMapComponent {}
